export const KEY = {
  en_US: 'Key',
  pt_BR: 'Chave',
  es_ES: 'Clave',
};

export const CREATED = {
  en_US: 'Created',
  pt_BR: 'Criada',
  es_ES: 'creada',
};

export const EDIT_PEMISSIONS = {
  en_US: 'Edit permissions',
  pt_BR: 'Editar permissões',
  es_ES: 'Editar permisos',
};

export const EDIT_PEMISSIONS_SUCCESS = {
  en_US: 'Permissions successfully updated!',
  pt_BR: 'Permissões atualizados com sucesso!',
  es_ES: '¡Los permisos se actualizaron correctamente!',
};

export const CAPABILITIES = {
  en_US: 'Capabilities',
  pt_BR: 'Capacidades',
  es_ES: 'Capacidades',
};

export const MEDICINE_EQUIVALENCE = {
  en_US: 'Medicine equivalent brands',
  es_ES: 'Marcas equivalentes de medicamentos',
  pt_BR: 'Marcas equivalentes de medicamentos',
};

export const CREATE_APPOINTMENTS = {
  en_US: 'Create appointments',
  es_ES: 'Crear citas',
  pt_BR: 'Criar agendamentos',
};

export const LIST_APPOINTMENTS = {
  en_US: 'List appointments',
  es_ES: 'Listar citas',
  pt_BR: 'Listar agendamentos',
};

export const DOMAINS = {
  en_US: 'Domains',
  es_ES: 'Dominios',
  pt_BR: 'Domínios',
};

export const ROTATE_KEY = {
  en_US: 'Rotate key',
  es_ES: 'Rotar clave',
  pt_BR: 'Rotacionar chave',
};

export const ROTATE_KEY_CONFIRMATION = {
  en_US: 'Do you want to rotate this key? This action cannot be undone.',
  es_ES: '¿Quieres rotar esta clave? Esta acción no se puede deshacer.',
  pt_BR: 'Deseja rotacionar esta chave? Essa ação não pode ser desfeita.',
};

export const LABEL_CONFIRM_ROTATE_KEY = {
  en_US: 'Yes, I want to rotate it',
  es_ES: 'Si, quiero rotar',
  pt_BR: 'Sim, quero rotacionar',
};

export const KEY_ROTATED_SUCCESSFULLY = {
  en_US: 'Key rotated successfully.',
  es_ES: 'Clave rotada exitosamente.',
  pt_BR: 'Chave rotacionada com sucesso.',
};

export const INVALIDATE_KEY = {
  en_US: 'Invalidate key',
  es_ES: 'Invalidar clave',
  pt_BR: 'Invalidar chave',
};

export const INVALIDATE_KEY_CONFIRMATION = {
  en_US: 'Do you want to invalidate this key? This action cannot be undone.',
  es_ES: '¿Quieres invalidar esta clave? Esta acción no se puede deshacer.',
  pt_BR: 'Deseja invalidar esta chave? Essa ação não pode ser desfeita.',
};

export const LABEL_CONFIRM_INVALIDATE_KEY = {
  en_US: 'Yes, I want to invalidate it',
  es_ES: 'Si, quiero invalidar',
  pt_BR: 'Sim, quero invalidar',
};

export const KEY_INVALIDATED_SUCCESSFULLY = {
  en_US: 'Key invalidated successfully.',
  es_ES: 'Clave invalidada exitosamente.',
  pt_BR: 'Chave invalidada com sucesso.',
};

export const ALREADY_INVALID_API_KEY = {
  en_US: 'This key is already invalidated.',
  es_ES: 'Esta clave ya está invalidada.',
  pt_BR: 'Essa chave já está invalidada.',
};

export const INVALIDATED_API_KEY = {
  en_US: 'Invalidated key',
  es_ES: 'Clave invalidada',
  pt_BR: 'Chave Invalidada',
};

export const NO_API_KEYS_CREATED_FOR_THIS_PARTNER = {
  en_US: 'No API keys were created for this partner',
  es_ES: 'No se crearon claves API para este socio',
  pt_BR: 'Nenhuma chave de API foi criada para este parceiro',
};

export const ADD_KEY_FOR_PARTNER = {
  en_US: 'Add API key for partner',
  es_ES: 'Agregar clave API para socio',
  pt_BR: 'Adicionar chave de API para parceiro',
};

export const CREATE_KEY_CONFIRMATION = {
  en_US: 'Do you want to create a new key for this partner?',
  es_ES: '¿Quieres crear una nueva clave para este socio?',
  pt_BR: 'Deseja criar uma nova chave para este parceiro?',
};

export const LABEL_CONFIRM_CREATE_KEY = {
  en_US: 'Yes, I want to create',
  es_ES: 'Si, quiero crear',
  pt_BR: 'Sim, quero criar',
};

export const KEY_CREATED_SUCCESSFULLY = {
  en_US: 'Key created successfully.',
  es_ES: 'Clave creada exitosamente.',
  pt_BR: 'Chave criada com sucesso.',
};
